/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { useEffect } from 'react';

/**
 * Sets the browser tab title reactively based on the i18n-resolved page title.
 * Falls back to "Housien" when no title is provided.
 */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title ? `${title} | Housien` : 'Housien';
  }, [title]);
}
